import Vue from 'vue';

export default {
  get (url, params={}) {
    return Vue.axios.get(url, {params});
  },
  getNameByAreaCode (areaCode) {
    return Vue.axios.get(`/api/v1.0/chanquan/area/getSiteNameByAreaCode/${areaCode}`);
  },
  getAreaInfoByName(name) {
    return Vue.axios.get(`/api/v1.0/chanquan/site/selectSiteInfoByDomain/${name}`);
  },
  // 获取租户信息
  getTenantAreaInfo() {
    return Vue.axios.get('/api/v1.0/chanquan/tenant/getTenantAreaInfo');
  },
  // 获取验证码
  getCodeImage () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getCaptchaImage/' + new Date().getTime());
  },
  // 登录系统-账号密码
  loginSystem (postData) {
    return Vue.axios.post('/api/v1.0/chanquan/user/login', postData);
  },
  // 登录系统-短信验证码
  loginSystemByMobile(postData) {
    return Vue.axios.post('/api/v1.0/chanquan/user/verifyLogin', postData);
  },
  // 获取短信验证码
  getSmsCode(postData) {
    return Vue.axios.post('/api/v1.0/chanquan/user/getSmsVerifyCodeByMobile', postData);
  },
  getSendVoiceCode(postData) {
    return Vue.axios.post('/api/v1.0/chanquan/user/getSmsVoiceVerifyCodeByMobile', postData);
  },
  // 获取短信验证码 登录的时候
  getSmsCodeSign(postData) {
    return Vue.axios.post('/api/v1.0/chanquan/user/sendSmsForLogin', postData);
  },
  // 根据类型查询字典列表
  getSelectList (dictId) {
    return Vue.axios.get('/api/v1.0/chanquan/dictionary/selectDictListByDictId/' + dictId);
  },
  // 获取用户基本信息
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },
  // 根据银行卡查询开户行
  getBankAddressByCard (bankCard) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getBankAddressByCard/' + bankCard);
  },
  // 根据银行卡查询连行号
  getCorrespondCodeByCardNo (bankCard) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getCorrespondCodeByCardNo/' + bankCard);
  },
  // 获取区域列表
  getLocationList(areaCode, level) {
    return Vue.axios.get('/api/v1.0/chanquan/area/selectAreaList/' + areaCode + '/' + level );
  },
  // 获取合同下载和预览地址
  getProjectContractUrl(params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/getContractUrlByProjectId', {params: params});
  },
  // 查询资讯列表
  getNewsList(params) {
    return Vue.axios.post('/api/v1.0/chanquan/news/selectNewsListByPage', params);
  },
  // 查询咨询详情
  getNewsDetail(params) {
    return Vue.axios.get('/api/v1.0/chanquan/news/getNewsById', {params});
  },
  // 获取E签宝签约地址
  getSignUrl(signCode) {
    return Vue.axios.get('/api/v1.0/chanquan/sign/contract/getSignUrl/' + signCode);
  },
  selectSiteInfoByDomain(domainName) {
    return Vue.axios.get('/api/v1.0/chanquan/site/selectSiteInfoByDomain/' + domainName);
  },
  // 获取最新版本号
  selectAppLastVersion() {
    return Vue.axios.get('/api/v1.0/chanquan/version/selectAppLastVersion');
  },
  // 转让/采购-生成跳转签约地址二维码
  generateSignQrCode(data) {
    return Vue.axios.post('/api/v1.0/chanquan/center/generateSignQrCode', data);
  },
  // 线上支付校验是否开通快捷支付
  checkOpenQuikPay(bidId) {
    return Vue.axios.get('/api/v1.0/bankCard/checkOpenQuikPay/' + bidId);
  },
  // 收银台
  getJNOrderApply(params) {
    return Vue.axios.post('/api/v1.0/chanquan/jiLinbank/GetJNOrderApply', params);
  },
  // 后端支付防双击
  generatorClickToken() {
    return Vue.axios.get('/api/v1.0/chanquan/bid/generatorClickToken');
  }
};
